import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import { _post } from '../../utils/network';

import Breadcrumb from '../../components/Breadcrumb/Breadcrumb.component';
import ListTable from '../../components/List/ListTable/ListTable.component';
import Pagination from '../../components/List/Pagination/Pagination.component';

import { sliderConfigs } from './sliderConfig';

const SliderBannersList = ({ source }) => {
	const config = sliderConfigs[source];
	const { t } = useTranslation();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t(config.titleKey), link: config.listPath },
		{ title: t('list') }
	];

	const [slides, setSlides] = useState([]);
	const slidesListData = {
		head: [t('image'), t('title'), t('link'), t('status'), t('operation')],
		body: slides.map(slide => [
			<img src={slide[config.imageKey]} alt="" />,
			slide[config.titleField],
			slide[config.linkKey],
			<span className={"badge rounded-pill p-2 badge-subtle-" + (slide.is_active ? 'success' : 'secondary')}>
				{slide.is_active ? t('active') : t('deactive')}
			</span>,
			<Link className='btn btn-secondary btn-sm p-1' to={`${config.listPath.replace('-list', '-edit')}/${slide[config.idKey]}`}>
				<i className="fa fa-edit"></i> {t('edit')}
			</Link>
		]),
		directions: ['', '', 'ltr', '', 'ltr']
	};

	const [pageNumber, setPageNumber] = useState(1);
	const [pageCounter] = useState(10);
	const [totalCount, setTotalCount] = useState(0);
	const [pagesCount, setPagesCount] = useState(0);
	const getSlides = async () => {
		let body = {
			is_active: null,
			page: pageNumber,
			count: pageCounter
		};
		let response = await _post(config.api + '/admin/getAll', body);
		switch(response.code){
			case 200:
				setTotalCount(response.data[config.countKey]);
				setSlides(response.data[config.listKey]);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};

	useEffect(() => {
		setPagesCount(Math.ceil(totalCount / pageCounter));
	}, [totalCount]);

	useEffect(() => {
		getSlides();
	}, [pageNumber, source]);

	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<ListTable title={t(config.titleKey)} pageNumber={pageNumber} pageCounter={pageCounter} totalCount={totalCount} data={slidesListData} />
			<Pagination pagesCount={pagesCount} action={setPageNumber} />
		</>
	);
};

export default SliderBannersList;
